import { render, staticRenderFns } from "./ConversationSidebar.vue?vue&type=template&id=18a1b0d7&scoped=true&"
import script from "./ConversationSidebar.vue?vue&type=script&lang=js&"
export * from "./ConversationSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ConversationSidebar.vue?vue&type=style&index=0&id=18a1b0d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a1b0d7",
  null
  
)

export default component.exports